import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Inject admin token from localStorage on every request (fallback when cookies don't survive cross-origin)
api.interceptors.request.use((config) => {
    try {
        const adminToken = localStorage.getItem("sf_admin_token");
        if (adminToken) {
            config.headers = config.headers || {};
            config.headers["X-Admin-Token"] = adminToken;
        }
    } catch (_) {}
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Si è verificato un errore. Riprova.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
